import { useEffect, useState } from 'react';

import { CheckCircleIcon } from '@heroicons/react/24/solid';

// Rotating email validation tips for educational value
const EMAIL_TIPS = [
  '73% of email delivery issues are caught in the first 24 hours',
  'SPF, DKIM, and DMARC together reduce spoofing by 96%',
  'Broken links are the #1 cause of failed email campaigns',
  'Images without alt text reduce accessibility by 40%',
  'Missing unsubscribe links can trigger spam filters instantly',
  'HTML validation prevents rendering issues across 50+ email clients',
  'Testing on mobile first catches 80% of design issues',
  'Personalization tokens should always have fallback values',
  'Preview text appears in 90% of mobile email clients',
  'Consistent sender domains improve deliverability by 30%',
];

export function LogoutSuccess() {
  // Select random tip on mount
  const [tip] = useState(() => EMAIL_TIPS[Math.floor(Math.random() * EMAIL_TIPS.length)]);

  // Clear any remaining auth state on mount
  useEffect(() => {
    // This ensures state is fully cleared after logout navigation
    const clearAuthState = async () => {
      try {
        // Dynamic import to avoid circular dependencies
        const { useStore } = await import('@/store');
        const store = useStore.getState();

        // Only clear if still authenticated (shouldn't be, but safety check)
        if (store.isAuthenticated) {
          store.setUser(null);
          store.setAccessToken(null);
          store.setTokenExpiry(null);
          store.setLoading(false);
        }
      } catch {
        // Ignore errors - state is already cleared
      }
    };

    clearAuthState();
  }, []);

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 px-4 dark:bg-gray-900">
      <div className="w-full max-w-md space-y-8 text-center">
        {/* Success Icon */}
        <div className="flex justify-center">
          <CheckCircleIcon className="h-16 w-16 text-green-600 dark:text-green-500" />
        </div>

        {/* Main Message */}
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
          You're signed out securely
        </h1>

        {/* Educational Tip */}
        <div className="rounded-lg bg-blue-50 p-4 dark:bg-blue-900/20">
          <p className="text-sm font-medium text-blue-900 dark:text-blue-100">💡 SendGuard tip</p>
          <p className="mt-1 text-sm text-blue-800 dark:text-blue-200">{tip}</p>
        </div>

        {/* Action Buttons */}
        <div className="space-y-3 pt-2">
          <a
            href="/login"
            className="inline-block w-full rounded-lg bg-blue-600 px-4 py-3 text-sm font-medium text-white transition-colors hover:bg-blue-700 focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:outline-none dark:focus:ring-offset-gray-900"
          >
            Sign back in
          </a>
          <a
            href="https://www.sendguard.io"
            className="inline-block w-full rounded-lg border border-gray-300 bg-white px-4 py-3 text-sm font-medium text-gray-700 transition-colors hover:bg-gray-50 focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 focus:outline-none dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300 dark:hover:bg-gray-700 dark:focus:ring-offset-gray-900"
          >
            Go to homepage
          </a>
        </div>
      </div>
    </div>
  );
}
